import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DocsService, IDbMappingBook, IEditMappingBookRequest } from '@shared/services/docs.service';

import { tagArray, TagsService } from '@shared/services/tags.service';
import { firstValueFrom, take } from 'rxjs';

@Component({
	selector: 'app-edit-mapping',
	templateUrl: './edit-mapping.component.html',
	styleUrls: ['./edit-mapping.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class EditMappingComponent implements OnInit {
	@Output() mappingEdited: EventEmitter<any> = new EventEmitter();
	mappingBook: IDbMappingBook; // JSON data obtained from API endpoint
	tagsString: string = ''; // String representation of tags
	systemMappings: any[] = []; // Array to hold system specific mappings
	tagsErrorMessage: string | null;

	constructor(
		private docsService: DocsService,
		public dialogRef: MatDialogRef<EditMappingComponent>,
		@Inject(MAT_DIALOG_DATA) public InjectMappingBook: IDbMappingBook,
		private translate: TranslateService,
		private validator: TagsService,
	) {}

	ngOnInit(): void {
		this.mappingBook = this.InjectMappingBook;

		this.tagsString = this.mappingBook.tags.map((tag) => `${tag.key}=${tag.value}`).join(', ');

		this.systemMappings = Object.entries(this.mappingBook.mappingDocument['--systemspecificmappings--']).map(([key, value]) => ({ key, value }));
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	onEdit(_: any) {
		this.tagsErrorMessage = this.validator.validateTags(this.tagsString);
	}

	async onSaveClick() {
		const self: string = this.mappingBook.self;
		const tagsDictionary: tagArray = {};
		const mappingsDictionary: tagArray = {};

		const tagsArray = this.tagsString.split(',');
		tagsArray.forEach((tag) => {
			const [key, value] = tag.split('=');
			tagsDictionary[key.trim()] = value.trim();
		});

		this.systemMappings.forEach((item) => {
			mappingsDictionary[item.key] = item.value;
		});

		const editMappingBook: IEditMappingBookRequest = {
			tags: tagsDictionary,
			mappingDocument: {
				'--systemspecificmappings--': mappingsDictionary,
			},
		};

		await firstValueFrom(this.docsService.updateMappingBook(self, editMappingBook).pipe(take(1)));

		this.mappingEdited.emit();
		this.dialogRef.close();
	}

	editTags() {
		this.mappingBook.tags = this.tagsString.split(',').map((tag) => {
			const [key, value] = tag.split(':');
			return { key, value };
		});
	}

	addRow() {
		this.systemMappings.push({ key: '', value: '' });
	}

	deleteRow(index: number) {
		this.systemMappings.splice(index, 1);
	}
}
